var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observe } from "mobx";
import { observer } from "mobx-react";
import { Icon, Loader, WrapWithAnimate } from "sb-resp-ui";
// external components
import * as CMP from "./components";
import { ButtonModifiers, OddsModifiers } from "../../enums";
import { excludeLetters } from "../../helpers";
/*
    Setup testing tools for MobX
    uncoment the <DevTools /> at the end of the YourbetMiniBetSlip component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }
let YourbetMiniBetSlip = class YourbetMiniBetSlip extends React.Component {
    constructor(props) {
        super(props);
        // setup dictionary
        this.dict = this.props.dict;
        // setup data provider
        this.state = {
            dataProvider: this.props.dataProvider
        };
        this.stakeInput = React.createRef();
        this.disposeStakeValue = observe(this.state.dataProvider, "stakeValue", o => {
            if (this.stakeInput.current) {
                this.stakeInput.current.value = o.newValue;
            }
        });
    }
    componentWillUnmount() {
        this.disposeStakeValue();
    }
    // TODO: Remove the ignore rule and cover with tests
    /* istanbul ignore next */
    renderSummary() {
        return (React.createElement("div", { className: "rj-yourbet__main-slide rj-yourbet__main-slide--center" },
            this.state.dataProvider.purchases.map(p => (this.state.dataProvider.isAccepted &&
                React.createElement("div", { className: "rj-yourbet__selections", key: `ticket-${p.id}` },
                    React.createElement(CMP.Summary, { txt_1: this.dict.Stake, txt_2: p.stake || "", odds: p.odds || "", returnTxt: this.dict.Return, returnValue: p.return || "", oddsModf: OddsModifiers.accepted }),
                    React.createElement(CMP.Market, { title: this.dict.TicketNumber, market: p.id })))),
            !this.state.dataProvider.selectionsCount && React.createElement(CMP.EmptyMsg, { label: this.dict.EmtyMsg })));
    }
    // TODO: Remove the ignore rule and cover with tests
    /* istanbul ignore next */
    renderFooter() {
        const leftComponentStake = this.state.dataProvider.leftComponentStake;
        const leftComponentButton = this.state.dataProvider.leftComponentButton;
        const rightComp = this.state.dataProvider.rightComponent;
        return (React.createElement("div", { className: "rj-yourbet__section rj-yourbet__footer" },
            leftComponentButton ?
                React.createElement(CMP.Button, { modifier: leftComponentButton.modifier, handler: leftComponentButton.handler }, leftComponentButton.label)
                :
                    React.createElement("div", { className: "rj-yourbet__stake" },
                        React.createElement(CMP.Button, { modifier: ButtonModifiers.stake, handler: leftComponentStake.buttons.left.handler, disabled: leftComponentStake.buttons.left.disabled },
                            React.createElement(Icon, { i: "i-14 i-o-yourbet-minus" })),
                        React.createElement(CMP.StakeInput, { provider: this.state.dataProvider, handler: leftComponentStake.handler, inputHandler: excludeLetters, type: this.props.stakeInputType }),
                        React.createElement(CMP.Button, { modifier: ButtonModifiers.stake, handler: leftComponentStake.buttons.right.handler, disabled: leftComponentStake.buttons.right.disabled },
                            React.createElement(Icon, { i: "i-14 i-o-yourbet-plus" }))),
            React.createElement(CMP.Button, { modifier: rightComp.modifier, handler: rightComp.handler, disabled: rightComp.disabled }, rightComp.label)));
    }
    // TODO: Remove the ignore rule and cover with tests
    /* istanbul ignore next */
    render() {
        const hasSelections = this.state.dataProvider.selectionsCount && !this.state.dataProvider.isAccepted ? " rj-yourbet__main--has-selections" : "";
        // TODO Use a setting to enable or disable the slide down animation on mount>
        return React.createElement(WrapWithAnimate, { shouldWrap: true, animation: "slideDown", duration: 200, runOnMount: true },
            React.createElement("div", { className: "rj-yourbet" },
                this.state.dataProvider.purchases.map(p => (this.state.dataProvider.messages(p.id).map((x, y) => (React.createElement(CMP.Message, { key: `${x.id}-${y}`, modifier: x.modifier, label: x.label, type: x.type, handler: x.handler }))))),
                React.createElement("div", { className: `rj-yourbet__main${hasSelections}` },
                    this.renderSummary(),
                    React.createElement("div", { className: "rj-yourbet__main-slide" },
                        React.createElement("div", { className: "rj-yourbet__selections" },
                            this.state.dataProvider.purchases.map(p => (this.state.dataProvider.selectionsCount > 0 && /*!this.state.dataProvider.isAccepted &&*/
                                React.createElement(CMP.Summary, { key: p.id, txt_1: this.state.dataProvider.selectionsCount, txt_2: this.dict.SelectionLabel, odds: p.odds || "", returnTxt: this.dict.Return, returnValue: p.return || "", oddsModf: p.oddsUpdated ? OddsModifiers.changed : OddsModifiers.default }))),
                            React.createElement("div", { className: "rj-yourbet__selection-list", ref: x => this.selections = x }, !this.state.dataProvider.isAccepted && this.state.dataProvider.provider.selections.map((sel, i) => (React.createElement(WrapWithAnimate, { key: sel.id, shouldWrap: i > 1, animation: "scroll", container: this.selections, axis: "x", runOnMount: true },
                                React.createElement(CMP.Market, { title: sel.name, market: sel.eventType, handler: () => { this.state.dataProvider.removeSelection(sel.id); }, isSuspended: sel.suspended, suspendedTxt: sel.suspended ? this.dict.Danger : "" })))))))),
                this.renderFooter(),
                this.state.dataProvider.isWaiting && React.createElement("div", { className: "rj-yourbet__loader" },
                    React.createElement(Loader, null))));
    }
};
YourbetMiniBetSlip = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], YourbetMiniBetSlip);
export { YourbetMiniBetSlip };
//# sourceMappingURL=YourbetMiniBetSlip.js.map